// extracted by mini-css-extract-plugin
module.exports = {"feedbackBtn":"feedbackBtn___2mVbr","disable":"disable___3rj5D","icon":"icon___mAhLS"};